import script from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.totalLinkCount > 0 ? _c('ProfileLinkWrapper', {
    attrs: {
      "padding-bottom": false
    },
    on: {
      "event": function ($event) {
        return _vm.$emit('event', $event);
      }
    }
  }, [_c('StackedLayout', {
    attrs: {
      "options": _vm.options,
      "is-loading": _vm.isLoadingLinks
    },
    on: {
      "open": function ($event) {
        return _vm.$emit('event', _vm.EVENTS.FEED_STACK_EXPANSION);
      },
      "event": _vm.handleEvent,
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var attrs = ref.attrs;
        return [_c('Alert', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.hasError,
            expression: "hasError"
          }],
          staticStyle: {
            "margin-bottom": "0.5rem"
          },
          attrs: {
            "color": "error",
            "aria-live": "assertive"
          }
        }, [_vm._v("\n      " + _vm._s(_vm.errorMessage || _vm.defaultError) + "\n    ")]), _vm._v(" "), _vm._l(_vm.linksToShow, function (link, i) {
          return _c(_vm.getLinkType(link), _vm._b({
            key: link._id.$oid,
            ref: "linkRefs",
            refInFor: true,
            tag: "component",
            attrs: {
              "link": link
            },
            on: {
              "click": function ($event) {
                return _vm.handleChildLinkClick($event, link, i);
              },
              "event": _vm.handleEvent
            }
          }, 'component', attrs, false));
        })];
      }
    }], null, false, 3768895794),
    model: {
      value: _vm.isExpanded,
      callback: function ($$v) {
        _vm.isExpanded = $$v;
      },
      expression: "isExpanded"
    }
  })], 1) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var ProfileGroup = __vue_component__;
export { ProfileGroup as default };